import React, { useState, useEffect } from 'react'
import FormInput from '../../../common/form/form-input'
import FormSelect from '../../../common/form/form-select';
import TogglePanel from '../../../common/toggle-panel';
import { fetchChains } from '../../../../modules/chains'

function Details(props) {
  const [location, setLocation] = useState(props.location);
  const [chains, setChains] = useState([]);

  useEffect(function () {
    setLocation(props.location)
  }, [props.location])

  useEffect(() => {
    fetchChains()
      .then((data) => {
        let _chains = data.map((ele) => ( { value: ele.id, label: ele.name }));
        setChains(_chains);
      })
  }, [])

  return (
    <div className="mx-auto max-w-7xl px-6 pb-6">
      <div className="bg-white shadow overflow-hidden sm:rounded-lg" id="details">
        <TogglePanel name='Details' initOpen={true}>
          <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
            <dl className="sm:divide-y sm:divide-gray-200">
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Name</strong></h3>
                  <p className="font-weight-light">
                    Internal name with more details
                  </p>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.name}
                    field="name"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Display Name</strong></h3>
                  <p className="font-weight-light">
                    Shown to end users
                  </p>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.display_name}
                    field="display_name"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Chain Number</strong></h3>
                  <p className="font-weight-light">
                    Unique external identifer for this location
                  </p>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormInput
                    value={location.chain_number}
                    field="chain_number"
                    className="shadow-sm w-full focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-400 rounded-md placeholder-gray-600"
                    updateField={props.updateField}
                  />
                </dd>
              </div>
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Status</strong></h3>
                  <ul className="font-weight-light">
                    <li>
                      Init: New location
                    </li>
                    <li>
                      Observe: Location is likely duplicate
                    </li>
                    <li>
                      Merge: Location confirmed duplicate, merge based on type
                    </li>
                    <li>
                      Review: Location has had all data processed, will be promoted to active within 1 week.
                    </li>
                    <li>
                      Active: Shown to users
                    </li>
                    <li>
                      Archive: Location confirmed closed, will be set to inactive after some time.
                    </li>
                    <li>
                      Inactive: Not shown to users
                    </li>
                  </ul>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1 col-span-1">
                  <FormSelect
                    value={location.status}
                    field="status"
                    handleChange={props.updateField}
                    className="bg-white border border-gray-400 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 w-full p-2.5"
                    options={[{
                      value: 'init', label: 'INIT'
                    }, {
                      value: 'observe', label: 'OBSERVE'
                    }, {
                      value: 'merge', label: 'MERGE'
                    }, {
                      value: 'review', label: 'REVIEW'
                    }, {
                      value: 'active', label: 'ACTIVE'
                    }, {
                      value: 'archive', label: 'ARCHIVE'
                    }, {
                      value: 'inactive', label: 'INACTIVE'
                    }]}
                  />
                </dd>
              </div>

              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Chain</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormSelect
                    value={location.chain_id}
                    field="chain_id"
                    handleChange={props.updateField}
                    className="bg-white border border-gray-400 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 w-full p-2.5"
                    placeholder={'Select Chain'}
                    options={chains}
                  />
                </dd>
              </div>
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                <dt className="text-sm font-medium text-gray-500">
                  <h3><strong>Secondary Chain</strong></h3>
                </dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-1">
                  <FormSelect
                    value={location.secondary_chain_id}
                    field="secondary_chain_id"
                    handleChange={props.updateField}
                    className="bg-white border border-gray-400 text-gray-900 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 w-full p-2.5"
                    placeholder={'Select Chain'}
                    options={chains}
                  />
                </dd>
              </div>
            </dl>
          </div>
        </TogglePanel>
      </div>
    </div>
  )
}

export default Details;